import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useContext, useMemo } from 'react';
import {
  DatePeriodTypesEnum,
  FilterContext,
  Flex,
  Icon,
  Text,
  getPeriodRangeByPeriodType,
  useScreenResolution,
} from 'dash-ui';

import { useGetFileDownloadsStatisticQuery } from 'gql/generated.graphql';

import DoughnutChart from './components/DoughnutChart/DoughnutChart';
import FileStatisticList from './components/FileStatisticList/FileStatisticList';
import { DownloadedFilesChartWraper } from 'pages/Dashboard/components/DownloadedFilesChartWidget/DownloadedFilesChartWidget.style';

const DownloadedFilesChartWidget = () => {
  const theme = useTheme();
  const { t } = useTranslation('pages');
  const { state: filterState } = useContext(FilterContext);
  const propertyId = filterState?.propertyId;
  const {
    devices: { isMobile },
  } = useScreenResolution();
  const { data } = useGetFileDownloadsStatisticQuery({
    variables: {
      filter: {
        propertyId: propertyId,
        dateRange: filterState.dateRange
          ? {
              startDate: filterState.dateRange?.startDate,
              endDate: filterState.dateRange?.endDate,
            }
          : getPeriodRangeByPeriodType(DatePeriodTypesEnum.CURRENT_WEEK),
      },
      sort: [
        { fieldName: 'count', sortOrder: 1 },
      ],
      pagination: {
        allowLimit: true,
        limit: 5,
      },
    },
    skip: propertyId === '' || propertyId === undefined,
  });

  const { totalCount } = useMemo(
    () => ({
      totalCount: data?.getFileDownloadsStatistic?.totalCount || 0,
    }),
    [data]
  );

  return (
    <DownloadedFilesChartWraper p={4} flexDirection="column" minHeight={356}>
      <Text semibold lg>
        {t('organizationDashboardPage.downloadedFilesTitle')}
      </Text>
      {totalCount ? (
        <Flex mt={8} w="100%" flexDirection={isMobile ? "column" : "row"} alignItems="center" flex={1}>
          <Flex mx={isMobile ? 0 : 5}>
            {data && <DoughnutChart data={data} totalCount={totalCount} />}
          </Flex>
          <Flex mx={isMobile ? 0 : 5} mt={isMobile ? 10 : 0} w="100%">
            {data && <FileStatisticList data={data} />}
          </Flex>
        </Flex>
      ) : (
        <Flex w="100%" alignItems="center" justifyContent="center" flex={1}>
          <Flex>
            <Icon name="fileCopy" size={82} color={theme.colors.b30} mr={6} />
            <Text semibold lg>
              {!filterState.dateRange
                ? t('organizationDashboardPage.downloadedFilesPlaceholderTitle')
                : t(
                    'organizationDashboardPage.widgetsEmptyFilterTexts.fileDownloads'
                  )}
            </Text>
          </Flex>
        </Flex>
      )}
    </DownloadedFilesChartWraper>
  );
};

export default DownloadedFilesChartWidget;
